import * as React from 'react';
import * as moment from 'moment';

import FilterPageHeader from '../../filter/components/filter-page-header';

import PromoCodeContainer  from '../../common/promo-code/promo-code';
import PriceTypeFilterContainer from '../../filter/components/price-type-filter-container';

import Modal from '../../common/modal/modal';
import ModalState from '../../common/modal/modal-states';

import { showLoadingScreen } from '../../actions/app-actions'
import { selectPriceTypeTickets } from '../../filter/actions/filter-actions';

import { applyPromoCode, cancelPromoApply, emptyCart, removePromoCode } from '../../filter/actions/promo-actions';
import { getSelectedTicketCount } from '../../helpers/price-type-helpers';
import { PriceType } from '../../classes/price-type';
import { connect } from 'react-redux';

import { ItemType } from '../../classes/item-type';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { IAppState } from '../../reducers/index';
import * as PropTypes from 'prop-types';

export interface IFilterState {
    validDate: boolean;
    showPerformanceSelector: boolean;
    showMissingTicketsError: boolean;
    invalidTicketsMessage: string;
    lastFocused: any;
    modalFocusableElements: any[];
};

class PackageQuantitySelect extends React.Component<IAppState, IFilterState>{
    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props) {
        super(props);
        // If no app settings are passed in, let it through until something comes.
        let hasNotPassed: boolean;
        if (props.appSettingsModel.performanceDate) {
            const currPerformanceDate = moment(props.appSettingsModel.performanceDate);
            hasNotPassed = currPerformanceDate.diff(moment()) >= 0;
        } else {
            hasNotPassed = true;
        }

        this.state = {
            validDate: hasNotPassed,
            showPerformanceSelector: !hasNotPassed,
            showMissingTicketsError: false,
            invalidTicketsMessage: "",
            lastFocused: null,
            modalFocusableElements: null
        };
    }

    get canProceed(): boolean {
        return getSelectedTicketCount(this.props.priceTypesModel) > 0;
    }

    get disableText(): string {
        if (this.canProceed) {
            return "";
        }

        return "disabled";
    }

    componentWillReceiveProps(props: IAppState) {
        // If no app settings are passed in, let it through until something comes.
        let hasNotPassed: boolean;
        if (props.appSettingsModel.performanceDate) {
            const currPerformanceDate = moment(props.appSettingsModel.performanceDate);
            hasNotPassed = currPerformanceDate.diff(moment()) >= 0;
        } else {
            hasNotPassed = true;
        }

        this.setState({
            validDate: hasNotPassed,
            showPerformanceSelector: !hasNotPassed,
            showMissingTicketsError: this.state.showMissingTicketsError,
            invalidTicketsMessage: this.state.invalidTicketsMessage,
            lastFocused: null,
            modalFocusableElements: null
        });
    }

    render() {
        const { itemType } = this.props.appSettingsModel;

        return (
            <div>
                <main className="filters-container" id="main-content">
                    <FilterPageHeader
                        title={this.props.appSettingsModel.subscriptionQuantitySelectPageHeaderTitle}
                        message={this.props.appSettingsModel.subscriptionQuantitySelectPageHeaderMessage} />

                    <PromoCodeContainer />
                    {/*
                     * <PromoCode {...this.props.promoCodeModel} onApplyPromoClick={this._onApplyPromoClick.bind(this)}
                        onCancelPromoClick={this._onCancelPromoClick.bind(this)}
                        onEmptyCartClick={this._onEmptyCartClick.bind(this)}
                        {...this.props.appSettingsModel}
                        onRemovePromoClick={this._onRemovePromoClick.bind(this)}
                        promoCodeTextTitle={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.title : ''}
                        promoCodeDescription={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.description : ''}
                        promoCodeRedirect={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.redirectURL : ''}
                        promoCodeText4={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.text4 : ''}
                        promoCodeText5={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.text5 : ''}
                        promoCodeText6={this.props.appSettingsModel.currentPromoCode != null ? this.props.appSettingsModel.currentPromoCode.text6 : ''}
                        showComponent={true} />
                     */}
                    
                    <PriceTypeFilterContainer
                        priceTypes={this.props.priceTypesModel.priceTypes}
                        onChangePriceTypeQuantity={this._onChangePriceTypeQuantity.bind(this)}
                        appSettingsModel={this.props.appSettingsModel}
                        showComponent={true} />
                </main>

                {
                    !this.props.appSettingsModel.itemOnSale ?
                        <Modal modalKey="performance not on sale" isError={true}
                            title={this.props.appSettingsModel.performanceNotOnSaleModalTitle}
                            message={this.props.appSettingsModel.performanceNotOnSaleModalMessage}
                            confirmFunction={this._performanceNotOnSaleRedirect.bind(this)}
                            confirmString={this.props.appSettingsModel.performanceNotOnSaleRedirectButtonText}
                            closeFunction={this._performanceNotOnSaleRedirect.bind(this)}
                        />
                        :
                        (
                            !this.props.appSettingsModel.itemOnSale ?
                                <Modal modalKey="performance sold out" isError={true}
                                    title={this.props.appSettingsModel.performanceSoldOutModalTitle}
                                    message={this.props.appSettingsModel.performanceSoldOutModalMessage}
                                    confirmFunction={this._performanceNotOnSaleRedirect.bind(this)}
                                    confirmString={this.props.appSettingsModel.performanceNotOnSaleRedirectButtonText}
                                    closeFunction={this._performanceNotOnSaleRedirect.bind(this)}
                                />
                                : null)
                }

                <footer className="footer-wrapper">

                    <div className="footer-container">
                        <button type="button" disabled={this.disableText.length > 0} onClick={() => this._onProceedClick()} className={"footer-link " + this.disableText}><span>{this.props.appSettingsModel.packageQuantityStepOneButton}</span></button>
                    </div>
                </footer>
            </div>

        );
    }

    _performanceNotOnSaleRedirect() {
        window.location.href = this.props.appSettingsModel.performanceNotOnSaleRedirectUrl;
    }

    _ticketQuantityZeroRedirect() {
        window.location.href = this.props.appSettingsModel.ticketQuantityZeroRedirectUrl;
    }

    _onProceedClick() {
        this.props.dispatch(showLoadingScreen());
        this.context.router.history.push("/filters");
    }

    _onChangePriceTypeQuantity(quantity: number, priceTypeId: number) {
        this.props.dispatch(selectPriceTypeTickets(priceTypeId, quantity, false, [], true));
    }

    _onApplyPromoClick(promoCode) {
        this.props.dispatch(applyPromoCode(promoCode));
    }

    _onCancelPromoClick(promoCode) {
        this.props.dispatch(cancelPromoApply());
    }

    _onRemovePromoClick(promoCode) {
        this.props.dispatch(removePromoCode());
    }

    _onEmptyCartClick(promoCode) {
        this.props.dispatch(emptyCart(promoCode));
    }
}

export default connect((state) => state)(PackageQuantitySelect);